import { api } from '../../DefaultService';
import {
  IHomeAssistantDeviceProps,
  IHomeAssistantDiscoveredEntity,
  IHomeAssistantGroupTriggerParams,
  IHomeAssistantTriggerParams,
  IHomeAssistantTriggerResult,
  ILinkHomeAssistantDeviceProps,
} from './types';

const ENDPOINT = '/v1/devices/home-assistant';
const DEVICE_GROUP_ENDPOINT = '/v1/devicegroup';

export const getDiscoveredHomeAssistantEntitiesAsync = async (): Promise<
  IHomeAssistantDiscoveredEntity[]
> => {
  return await api
    .get(`${ENDPOINT}/discovered`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllHomeAssistantDevicesByLicenseAsync = async (): Promise<
  IHomeAssistantDeviceProps[]
> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const linkHomeAssistantDeviceAsync = async (
  data: ILinkHomeAssistantDeviceProps,
): Promise<IHomeAssistantDeviceProps> => {
  return await api
    .post(`${ENDPOINT}/link`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const triggerHomeAssistantDeviceAsync = async ({
  id,
  data,
}: IHomeAssistantTriggerParams): Promise<IHomeAssistantTriggerResult> => {
  return await api
    .post(`${ENDPOINT}/${id}/trigger`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const triggerHomeAssistantGroupAsync = async ({
  groupId,
  data,
}: IHomeAssistantGroupTriggerParams): Promise<IHomeAssistantTriggerResult[]> => {
  return await api
    .post(`${DEVICE_GROUP_ENDPOINT}/${groupId}/trigger`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
